import React from 'react';
import './Footer.css';

function Footer() {
  return (
    <footer>
      <div className="footer-nav">
        <a href="/#howitworks">How It Works</a>
        <a href="/contact-us/">Contact Us</a>
        <a href="/privacy">Privacy & Terms</a>
      </div>
      <div className="footer-copyright">
        <p>LeasEiZi.com</p>
        <p>Copyright 2026</p>
      </div>
    </footer>
  );
}

export default Footer;